export const landlordPoliciesContainFees = text => {
  const pattern = new RegExp('(euro|EUR|€)', 'g');
  const matches = pattern.exec(text);
  return !!matches;
};
